
import {Component, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import ConfirmDialog from "../ConfirmDialog.vue";
import {currentUserModule, ntdInstitutesModule} from "@/store";
import Rights = MdbsCore.Rights;
import INtdInstituteCreateDto = MdbsCore.INtdInstituteCreateDto;
import NtdInstituteCreateDto = MdbsCore.NtdInstituteCreateDto;
import INtdInstituteShortDto = MdbsCore.INtdInstituteShortDto;
import NtdInstituteEditDialog from "@/components/ntd/NtdInstituteEditDialog.vue";
import NtdInstituteCreateDialog from "@/components/ntd/NtdInstituteCreateDialog.vue";

@Component({
  components: {
    NtdInstituteCreateDialog,
    NtdInstituteEditDialog,
    ConfirmDialog
  },
})
export default class NtdInstituteTable extends Vue {

  toBeUpdatedItem: INtdInstituteShortDto | null = null;
  showUpdateDialog = false;
  toBeCreatedItem: INtdInstituteCreateDto | null = null;
  showCreateDialog = false;

  headers: Array<any> = [
    {
      text: "Kennung",
      value: "studyInstitute.identifier"
    },
    {
      text: "Anzeigename",
      value: "studyInstitute.displayName"
    },
    {
      text: "Ntd Id",
      value: "id"
    },
    {
      text: "Aktiviert",
      value: "isNtdInstitute"
    },
    {
      text: 'Aktionen',
      sortable: false,
      width: '60px',
      value: 'actions'
    }
  ]
  options: any = {
    sortBy: ['displayName'],
    sortDesc: [false]
  };
  search: string = "";

  get canUpdate() {
    return currentUserModule.hasRight(Rights.NtdInstituteUpdateCmd);
  }

  get canCreate() {
    return currentUserModule.hasRight(Rights.NtdInstituteCreateCmd);
  }

  get ntdInstitutes() {
    return ntdInstitutesModule.ntdInstitutes;
  }

  get loading() {
    return ntdInstitutesModule.isLoading;
  }

  async mounted() {

  }

  cancelUpdate() {
    this.toBeUpdatedItem = null;
  }

  createNtdInstitute() {
    this.toBeCreatedItem = new NtdInstituteCreateDto();
    this.showCreateDialog = true;
  }

  async updateInstitute(institute: INtdInstituteShortDto) {
    this.toBeUpdatedItem = institute;
    this.showUpdateDialog = true;
  }
}

